import Vue from 'vue'
import Router from 'vue-router'
import storeData from '../store/index.js'
// import Assessment from '../pages/assessment/assessment.vue' //考核
// import ThematicExercises from '../pages/assessment/thematicExercises.vue' // 专题练习
// import ComprehensiveExamination from '../pages/assessment/ComprehensiveExamination.vue' // 综合考试
// import Mistakes from '../pages/assessment/mistakes.vue' // 错题集
// import AnnualExamination from '../pages/assessment/AnnualExamination.vue' // 年度考试


// import Mine from '../pages/mine/mine.vue' // 个人中心
// import UserCenter from '../pages/mine/userCenter.vue' // 个人信息
// import MyCourse from '../pages/mine/myCourse.vue' // 我的课程
// import MyAssess from '../pages/mine/myAssess.vue' // 我的考核
// import Comprehensive from '../pages/mine/comprehensive.vue' // 综合考试
// import MyIntegral from '../pages/mine/myIntegral .vue' // 我的积分
// import RankingList from '../pages/mine/rankingList.vue' // 排行榜
// import Instructions from '../pages/mine/instructions.vue' // 使用说明
// import IntegralDescription from '../pages/mine/integralDescription.vue' // 积分说明


// import Course from '../pages/course/course.vue' // 课程
// import Preview from '../pages/course/preview.vue' // 考卷预览
// import CourseInfo from '../pages/course/courseInfo.vue' // 课程详情
// import kcxq from '../pages/course/kcxq.vue'
// import dgkh from '../pages/course/dgkh.vue' // 导购考核

// import Administration from '../pages/administration/administration.vue' // 管理
// import AnnouncementDetail from '../pages/administration/announcementDetail.vue' // 公告详情

// import PersonInfo from '../pages/personInfo/personInfo.vue' // 完善个人资料
// import ExamPaper from '../comment/index.vue' // 考卷
// import assessmentPaper from '../pages/assessment/assessmentPaper.vue' // 专题考试试卷
// import MistakesPaper from '../pages/assessment/mistakesPaper.vue' // 错题考试试卷
// import Finshed from '../pages/assessment/finshed.vue' // 考卷完成

// import examinationPaper from '../pages/assessment/examinationPaper.vue' // 测试视频播放插件
Vue.use(Router)
const router = new Router({
  mode: "history",
  routes: [
    // 重定向
    {
      path: '/',
      name: 'Course',
      // component: Course
      component: resolve=>{
        require(['../pages/course/course.vue'],resolve)
      },
      meta:{
        keepAlive: true,
        scollTopPosition: 0
      }
    },
    // 课程
    {
      path: '/course',
      name: 'Course',
      // component: Course
      component: resolve=>{
        require(['../pages/course/course.vue'],resolve)
      },
      meta:{
        keepAlive: true,
        scollTopPosition: 0
      }
    },
    {
      path: '/perview',
      name: 'Preview',
      // component: Preview
      component: resolve=>{
        require(['../pages/course/preview.vue'],resolve)
      },
      meta:{
        keepAlive: false,
        scollTopPosition: 0
      }
    },
    {
      path: '/courseInfo',
      name: 'CourseInfo',
      // component: CourseInfo
      component: resolve=>{
        require(['../pages/course/courseInfo.vue'],resolve)
      },
      meta:{
        keepAlive: false,
        scollTopPosition: 0
      }
    },
    {
      path: '/kcxq',
      name: 'kcxq',
      // component: kcxq
      component: resolve=>{
        require(['../pages/course/kcxq.vue'],resolve)
      },
      meta:{
        keepAlive: false,
        scollTopPosition: 0
      }
    },
    {
      path: '/dgkh',
      name:'dgkh',
      // component: dgkh
      component: resolve=>{
        require(['../pages/course/dgkh.vue'],resolve)
      },
      meta:{
        keepAlive: false,
        scollTopPosition: 0
      }
    },
    // 考核
    {
      path: '/assessment',
      name: 'Assessment',
      // component: Assessment
      component: resolve=>{
        require(['../pages/assessment/assessment.vue'],resolve)
      },
      meta:{
        keepAlive: true,
        scollTopPosition: 0
      }
    },
    // 专题练习
    {
      path: '/thematicExercises',
      name: 'thematicExercises',
      // component: ThematicExercises
      component: resolve=>{
        require(['../pages/assessment/thematicExercises.vue'],resolve)
      },
      meta:{
        keepAlive: false,
        scollTopPosition: 0
      }
    },
    {
      path: '/assessmentPaper',
      name: 'assessmentPaper',
      // component: assessmentPaper
      component: resolve=>{
        require(['../pages/assessment/assessmentPaper.vue'],resolve)
      },
      meta:{
        keepAlive: false,
        scollTopPosition: 0
      }
    },
    // 综合考试
    {
      path: '/comprehensiveExamination',
      name: 'comprehensiveExamination',
      // component: ComprehensiveExamination
      component: resolve=>{
        require(['../pages/assessment/ComprehensiveExamination.vue'],resolve)
      },
      meta:{
        keepAlive: false,
        scollTopPosition: 0
      }
    },
    // 错题集
    {
      path: '/mistakes',
      name: 'mistakes',
      // component: Mistakes
      component: resolve=>{
        require(['../pages/assessment/mistakes.vue'],resolve)
      },
      meta:{
        keepAlive: false,
        scollTopPosition: 0
      }
    },
    {
      path: '/mistakesPaper',
      name: 'mistakesPaper',
      // component: MistakesPaper
      component: resolve=>{
        require(['../pages/assessment/mistakesPaper.vue'],resolve)
      },
      meta:{
        keepAlive: false,
        scollTopPosition: 0
      }
    },
    // 年度考试
    {
      path: '/annualExamination',
      name: 'annualExamination',
      // component: AnnualExamination
      component: resolve=>{
        require(['../pages/assessment/AnnualExamination.vue'],resolve)
      },
      meta:{
        keepAlive: false,
        scollTopPosition: 0
      }
    },
    // 管理
    {
      path: '/administration',
      name: 'Administration',
      // component: Administration
      component: resolve=>{
        require(['../pages/administration/administration.vue'],resolve)
      },
      meta:{
        keepAlive: true,
        scollTopPosition: 0
      }
    },
    {
      path: '/announcementDetail',
      name: 'AnnouncementDetail',
      // component: AnnouncementDetail
      component: resolve=>{
        require(['../pages/administration/announcementDetail.vue'],resolve)
      },
      meta:{
        keepAlive: false,
        scollTopPosition: 0
      }
    },
    // 我的
    {
      path: '/mine',
      name: 'Mine',
      // component: Mine
      component: resolve=>{
        require(['../pages/mine/mine.vue'],resolve)
      },
      meta:{
        keepAlive: true,
        scollTopPosition: 0
      }
    },
    // 个人信息
    {
      path: '/userCenter',
      name: 'UserCenter',
      // component: UserCenter
      component: resolve=>{
        require(['../pages/mine/userCenter.vue'],resolve)
      },
      meta:{
        keepAlive: false,
        scollTopPosition: 0
      }
    },
    // 我的课程
    {
      path: '/myCourse',
      name: 'myCourse',
      // component: MyCourse
      component: resolve=>{
        require(['../pages/mine/myCourse.vue'],resolve)
      },
      meta:{
        keepAlive: true,
        scollTopPosition: 0
      }
    },
    // 我的考核
    {
      path: '/myAssess',
      name: 'myAssess',
      // component: MyAssess
      component: resolve=>{
        require(['../pages/mine/myAssess.vue'],resolve)
      },
      meta:{
        keepAlive: true,
        scollTopPosition: 0
      }
    },
    // 综合考试
    {
      path: '/comprehensive',
      name: 'comprehensive',
      // component: Comprehensive
      component: resolve=>{
        require(['../pages/mine/comprehensive.vue'],resolve)
      },
      meta:{
        keepAlive: false,
        scollTopPosition: 0
      }
    },
    // 我的积分
    {
      path: '/myIntegral',
      name: 'myIntegral',
      // component: MyIntegral
      component: resolve=>{
        require(['../pages/mine/myIntegral .vue'],resolve)
      },
      meta:{
        keepAlive: false,
        scollTopPosition: 0
      }
    },
    // 排行榜
    {
      path: '/rankingList',
      name: 'rankingList',
      // component: RankingList
      component: resolve=>{
        require(['../pages/mine/rankingList.vue'],resolve)
      },
      meta:{
        keepAlive: false,
        scollTopPosition: 0
      }
    },
    // 使用说明
    {
      path: '/instructions',
      name: 'instructions',
      // component: Instructions
      component: resolve=>{
        require(['../pages/mine/instructions.vue'],resolve)
      },
      meta:{
        keepAlive: true,
        scollTopPosition: 0
      }
    },
    // 积分说明
    {
      path: '/integralDescription',
      name: 'integralDescription',
      // component: IntegralDescription
      component: resolve=>{
        require(['../pages/mine/integralDescription.vue'],resolve)
      },
      meta:{
        keepAlive: true,
        scollTopPosition: 0
      }
    },

    // 完善个人资料
    {
      path: '/personInfo',
      name: 'PersonInfo',
      // component: PersonInfo
      component: resolve=>{
        require(['../pages/personInfo/personInfo.vue'],resolve)
      },
      meta:{
        keepAlive: false,
        scollTopPosition: 0
      }
    },
    // 考卷(专题练习和错题集)
    {
      path: '/examPaper',
      name: 'examPaper',
      // component: ExamPaper
      component: resolve=>{
        require(['../comment/index.vue'],resolve)
      },
      meta:{
        keepAlive: false,
        scollTopPosition: 0
      }
    },
    // 错误页面
    {
      path: '/error',
      name: 'error',
      // component: ExamPaper
      component: resolve=>{
        require(['../pages/404.vue'],resolve)
      },
      meta:{
        keepAlive: true,
        scollTopPosition: 0
      }
    },
    // 考卷完成
    {
      path: '/finshed',
      name: 'finshed',
      // component: Finshed
      component: resolve=>{
        require(['../pages/course/course.vue'],resolve)
      },
      meta:{
        keepAlive: false,
        scollTopPosition: 0
      }
    },
    // 授权页面
    {
      path: '/OAuth',
      name: 'oauth',
      component: resolve=>{
        require(['../pages/oauth.vue'],resolve)
      },
      meta:{
        keepAlive: true,
        scollTopPosition: 0
      }
    },
    {
      path: '/examinationPaper',
      name: 'examinationPaper',
      // component: examinationPaper
      component: resolve=>{
        require(['../pages/assessment/examinationPaper.vue'],resolve)
      },
      meta:{
        keepAlive: true,
        scollTopPosition: 0
      }
    }
  ]
})


// router.beforeEach((to, from, next) => {
//   // setTimeout(()=>{
//     if(window.sessionStorage.getItem('_t')&&storeData.token){
//       next();
//     } else {
//       // 刷新 token 
//       var timer = setInterval(()=>{
//         if((window.sessionStorage.getItem('_t')&&storeData.token)||(window.localStorage.getItem('_t')&&storeData.token)){
//           clearInterval(timer);
//           next();
//         }
//       },10)
//     }
//   // },500)
  
// })

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js